import { FormEvent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useSession } from '../context/SessionContext';

export function CheckoutPage() {
  const { listingId = '' } = useParams();
  const { authenticated, startKeyra } = useSession();
  const [orderId, setOrderId] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!authenticated) void startKeyra(`/checkout/${listingId}`);
  }, [authenticated, listingId, startKeyra]);

  async function startCheckout(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const order = await api.checkout(listingId);
      setOrderId(order.orderId);
      setMessage('Order pending — browser redirect alone cannot grant download rights.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Checkout failed');
    }
  }

  async function confirmDevPayment() {
    if (!orderId) return;
    try {
      const result = await api.devConfirmPayment(orderId, `pay_evt_${Date.now()}`);
      setMessage(`Server-verified payment. Entitlement ${result.entitlementId ?? 'granted'}.`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Payment confirm failed');
    }
  }

  if (!authenticated) {
    return (
      <main className="page">
        <p className="muted">Continue with Keyra to purchase.</p>
      </main>
    );
  }

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Checkout</h1>
      <p className="muted">
        Fees are configurable until commercial terms are established. .spinit is not marketed as
        unextractable DRM.
      </p>
      <form className="panel" style={{ maxWidth: 480, marginTop: '1rem' }} onSubmit={startCheckout}>
        <p className="mono">Listing {listingId}</p>
        <button className="btn primary" type="submit">
          Place order
        </button>
      </form>
      {orderId && (
        <div className="panel" style={{ maxWidth: 480, marginTop: '1rem' }}>
          <p>Order {orderId}</p>
          <button type="button" className="btn primary" onClick={() => void confirmDevPayment()}>
            Dev: server-confirm payment event
          </button>
        </div>
      )}
      {message && <p>{message}</p>}
      {error && <p className="err">{error}</p>}
    </main>
  );
}
